module.exports = __webpack_public_path__ + "static/media/checkin-complete.3d03f476.jpg";